import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrigger = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M24.627 7.5h55.747a7.11 7.11 0 0 1 7.126 7.126v23.747c0 7.926-4.794 27.756-16.083 39.044S44.94 97.5 36.373 97.5H24.626a7.11 7.11 0 0 1-7.126-7.126V14.627a7.11 7.11 0 0 1 7.126-7.126z" })
});
export default SvgTrigger;
